// Centralized image references (Unsplash placeholders - replaceable later)
export const IMAGES = {
  hero: [
    "/assets/nyex19fy_Bellagio_tramonto.jpg",
    "/assets/4vfmelcj_167-lago_como-bellagio-paese.avif",
    "/assets/mve77k5e_Sito-web1.avif",
  ],
  rooms: {
    rosso_granato: [
      "/assets/jbhnyor6_BandB_Silvia------127.jpg",
      "/assets/ijr8qxhq_vista_finestra_rossa.jpg",
      "/assets/rfamux1h_BandB_Silvia------115.jpg",
      "/assets/aqcmaiol_BandB_Silvia------125.jpg",
      "/assets/led3hdc2_BandB_Silvia------116.jpg",
      "/assets/nqku395u_BandB_Silvia------128.jpg",
      "/assets/cvc0ufau_20190826_123459.jpg",
      "/assets/6agwmvas_BandB_-_Ronco__72_.JPG",
      "/assets/x1ecutgi_BandB_-_Ronco__65_.JPG",
      "/assets/79vytrjy_BandB_Silvia------122.jpg",
      "/assets/xa8uzf3s_BandB_Silvia------129.jpg",
      "/assets/rmwvbd27_BandB_Silvia------131.jpg",
      "/assets/6wwi0q7c_BandB_Silvia------132.jpg",
    ],
    verde_foresta: [
      "/assets/dseqj13f_BandB_Silvia------90.jpg",
      "/assets/w4fy8bsj_BandB_Silvia------99.jpg",
      "/assets/ynzykaac_BandB_Silvia------84.jpg",
      "/assets/ybhplbmb_BandB_Silvia------88.jpg",
      "/assets/7j5w4iho_BandB_Silvia------102.jpg",
      "/assets/mvfpx44u_BandB_Silvia------106.jpg",
    ],
    blu_marino: [
      "/assets/3igb0p72_BandB_Silvia------63.jpg",
      "/assets/lx43awx8_20190705_084302.jpg",
      "/assets/o96g5bm6_BandB_Silvia------74.jpg",
      "/assets/wii0tt87_BandB_Silvia------58.jpg",
      "/assets/pvhi5qwr_BandB_Silvia------56.jpg",
      "/assets/az93dscp_BandB_Silvia------55.jpg",
      "/assets/242lqxqe_BandB_Silvia------67.jpg",
      "/assets/y5lwclg6_BandB_Silvia------73.jpg",
      "/assets/d9ci2fiq_BandB_Silvia------135.jpg",
    ],
  },
  gallery: [
    "/assets/ryum7gk8_20200619_113041.jpg",
    "/assets/wq5srgg3_vista_lago_cortile.jpg",
    "/assets/3nkgec61_Bellagio-perla-del-Lago-di-Como-Visitare-il-Lago-di-Como.png",
    "/assets/rstvlaob_BandB_Silvia------150.jpg",
    "/assets/rzh4d5kj_20170429_165008_001.jpg",
    "/assets/mve77k5e_Sito-web1.avif",
    "/assets/q6p3m8uo_terrazza.jpg",
    "/assets/3hz0xust_Bici_san_giovanni.avif",
  ],
  bellagio: {
    history: "/assets/4vfmelcj_167-lago_como-bellagio-paese.avif",
    pearl: "/assets/1s8k3o9a_20231117_160126.jpg",
    villas: [
      "/assets/iazijvt3_20200507_153656.jpg",
      "/assets/pkfefj8f_20230424_181806.jpg",
    ],
    boats: "/assets/ius2fcv6_battello.avif",
    food: "/assets/a59tbreh_1782029151592.png",
    walks: "/assets/3hz0xust_Bici_san_giovanni.avif",
    junglerider: "https://images.unsplash.com/photo-1601224335112-b9b8d1ce82b0?auto=format&fit=crop&w=1400&q=80",
  },
  about: "https://images.unsplash.com/photo-1530841377377-3ff06c0ca713?auto=format&fit=crop&w=1400&q=80",
  aboutGallery: [
    "/assets/llnqnkwv_BandB_Silvia------53.jpg",
    "/assets/dp043x95_BandB_Silvia------108.jpg",
    "/assets/3igb0p72_BandB_Silvia------63.jpg",
    "/assets/uknelq47_20200503_141825.jpg",
  ],
  breakfast: [
    "/assets/aew6x4ld_BandB_Silvia------27.jpg",
    "/assets/e1dn0j2l_BandB_Silvia------23.jpg",
    "/assets/v0lojuhg_BandB_Silvia------30.jpg",
  ],
  // Dedicated breakfast & buffet gallery (page "La nostra colazione")
  // Order is intentionally mixed: cakes/desserts are spread between savoury, coffee and fruit shots.
  breakfastGallery: [
    "/assets/aew6x4ld_BandB_Silvia------27.jpg",
    "/assets/e1dn0j2l_BandB_Silvia------23.jpg",
    "/assets/9q6ges8y_file_00000000e76071f4b1e46009946f1c04.png",
    "/assets/v0lojuhg_BandB_Silvia------30.jpg",
    "/assets/s3q9gip4_BandB_Silvia------111.jpg",
    "/assets/alsntpxw_BandB_Silvia------33.jpg",
    "/assets/8jnew0cl_BandB_Silvia------32.jpg",
    "/assets/2sgvw7n1_file_00000000e440720ab36b7e51a4f40e48.png",
    "/assets/dlwqbvmw_BandB_Silvia------39.jpg",
    "/assets/64e0s0oj_20190720_081518.jpg",
    "/assets/74yc3fwj_20190602_094349.jpg",
    "/assets/wcv3b1td_BandB_Silvia------47.jpg",
    "/assets/xarbrymx_file_00000000259071f4af8da3d472411293.png",
    "/assets/79swzaz8_BandB_Silvia------109.jpg",
    "/assets/g2xn6i3v_20190602_094150.jpg",
    "/assets/8nuf05rm_BandB_Silvia------48.jpg",
    "/assets/g1cegxhc_BandB_Silvia------26.jpg",
    "/assets/efg5oqr6_BandB_Silvia------45.jpg",
    "/assets/6shzj2yy_BandB_Silvia------44.jpg",
    "/assets/as3c92yx_BandB_Silvia------34.jpg",
  ],
};

export const ROOMS = [
  { slug: "rosso_granato", color: "#7A2B33" },
  { slug: "verde_foresta", color: "#2A4B3C" },
  { slug: "blu_marino", color: "#1D3557" },
];

export const ROOM_SPECS = {
  rosso_granato: {
    size: "22 m²",
    maxGuests: 3,
    beds: { it: "1 letto matrimoniale Queen + 1 letto singolo", en: "1 Queen double bed + 1 single bed", fr: "1 lit Queen double + 1 lit simple" },
    amenities: ["ac", "wifi", "tv", "minibar", "privateBath", "shower", "desk", "towels", "hairdryer", "extraCot", "netflix", "tea"],
  },
  verde_foresta: {
    size: "19 m²",
    maxGuests: 2,
    beds: { it: "1 letto matrimoniale Queen", en: "1 Queen double bed", fr: "1 lit Queen double" },
    amenities: ["ac", "wifi", "tv", "minibar", "privateBath", "shower", "desk", "towels", "hairdryer", "extraCot", "netflixDisney", "tea"],
  },
  blu_marino: {
    size: "19 m²",
    maxGuests: 2,
    beds: { it: "1 letto matrimoniale Queen", en: "1 Queen double bed", fr: "1 lit Queen double" },
    amenities: ["ac", "exclusiveTerrace", "wifi", "tv", "minibar", "privateBath", "shower", "desk", "towels", "hairdryer", "extraCot", "netflix", "tea"],
  },
};

export const CONTACT = {
  phone: "+393519784545",
  phoneDisplay: "+39 351 978 4545",
  whatsapp: "393519784545",
  instagram: "https://www.instagram.com/ilakeitbellagio/?hl=it",
  email: "ilakeitbellagio@gmail.com",
  address: "Via Privata delle Robinie 12, 22021 Bellagio (CO)",
  mapsQuery: "45.9703849,9.243819",
  cir: "013250-BEB-00014",
  cin: "IT013250C1P3L4RR5K",
};
